import React from "react"
import Layout from "../../components/layout"
import { CodeExample } from "../../components/validatorFuncs"

const kmExample1 = `var validator = new ValidatorBuilder<Employee>()
    .NotNull(key: "NullEmployee") // or .NotNull("NullEmployee")
    .Build();
    
var result = validator.Validate(null);
var brokenRule = result.BrokenRules.First();

Console.WriteLine($"[{rule.Rule}] {rule.Key}: {rule.Message}");

// output
// [NotNull] NullEmployee: Value cannot be null.`

const kmExample2 = `var validator = new ValidatorBuilder<Employee>()
    .Required(e => e.FirstName, message: "Please provide first name.")
    .Build();
    
var result = validator.Validate(new Employee { LastName = "Smithers" });
var brokenRule = result.BrokenRules.First();

Console.WriteLine($"[{rule.Rule}] {rule.Key}: {rule.Message}");

// output
// [Required] FirstName: Please provide first name.`

const kmExample3 = `var validator = new ValidatorBuilder<Employee>()
    .Required(e => e.FirstName, "EmployeeFirstName", "Please provide first name.")
    .Build();
    
var result = validator.Validate(new Employee { LastName = "Smithers" });
var brokenRule = result.BrokenRules.First();

Console.WriteLine($"[{rule.Rule}] {rule.Key}: {rule.Message}");

// output
// [Required] EmployeeFirstName: Please provide first name.`

const KeysAndMessages = () => (
  <Layout>
    <h1>Keys and Messages</h1>
    <p>
      All built-in validation functions provide the ability to set the key of
      the value being validated and also customise the error message.
    </p>
    <p>
      Keys and messages are set via optional parameters and are passed to the
      broken rules collection during validation.
    </p>
    <hr className="my-6" />
    <h5 className="font-semibold text-gray-800 text-sm my-4">Example Usage</h5>
    <CodeExample code={kmExample1} label="Example setting the key." />
    <CodeExample code={kmExample2} label="Example setting the message." />
    <CodeExample code={kmExample3} label="Example setting key and message." />
  </Layout>
)

export default KeysAndMessages
